export const STORAGE = 'STORAGE'
export default STORAGE;